module.exports = __webpack_public_path__ + "static/media/old-glory-curbing.61331c2b.jpg";